(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["rare-way-shipping-calculator"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rw-shipping-calculator')) {
    class RwShippingCalculator extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('.rw-shipping__form');
        this.input = this.querySelector('.rw-shipping__input');
        this.button = this.querySelector('.rw-shipping__button');
        this.result = this.querySelector('.rw-shipping__result');
        this.input.addEventListener('input', () => {
          const digits = this.input.value.replace(/\D/g, '').slice(0, 8);
          this.input.value = digits.length > 5 ? `${digits.slice(0, 5)}-${digits.slice(5)}` : digits;
        });
        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          this.calculate();
        });
      }

      get root() {
        return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      }

      get variantId() {
        const scope = this.closest('.product-information, .shopify-section') || document;
        const field = scope.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
        return (field && field.value) || this.dataset.variantId;
      }

      show(html) {
        this.result.innerHTML = html;
        this.result.hidden = false;
      }

      escape(value) {
        const element = document.createElement('span');
        element.textContent = String(value);
        return element.innerHTML;
      }

      formatMoney(value) {
        const amount = Number(value);
        if (amount === 0) return 'Grátis';
        return amount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
      }

      formatDays(days) {
        if (!Array.isArray(days) || days.length === 0) return '';
        const [min, max] = days;
        if (min == null && max == null) return '';
        if (min === max || max == null) return `${min} ${min === 1 ? 'dia útil' : 'dias úteis'}`;
        if (min == null) return `até ${max} dias úteis`;
        return `${min} a ${max} dias úteis`;
      }

      async postJson(path, body) {
        return fetch(`${this.root}${path}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
      }

      async fetchRates(query) {
        const prepare = await fetch(`${this.root}cart/prepare_shipping_rates.json?${query}`, { method: 'POST' });
        if (!prepare.ok) {
          const error = await prepare.json().catch(() => null);
          throw new Error(error && error.zip ? 'invalid' : 'failed');
        }
        for (let attempt = 0; attempt < 15; attempt++) {
          const response = await fetch(`${this.root}cart/async_shipping_rates.json?${query}`);
          if (!response.ok) throw new Error('failed');
          const text = await response.text();
          if (text && text !== 'null') return JSON.parse(text).shipping_rates || [];
          await new Promise((resolve) => setTimeout(resolve, 600));
        }
        throw new Error('failed');
      }

      async calculate() {
        const zip = this.input.value.replace(/\D/g, '');
        if (zip.length !== 8) {
          this.show('<p class="rw-shipping__message">Digite um CEP válido com 8 números.</p>');
          this.input.focus();
          return;
        }

        const variantId = this.variantId;
        if (!variantId) return;

        this.button.disabled = true;
        this.button.textContent = 'Calculando...';
        this.result.hidden = true;

        let addedQuantity = 0;
        let originalQuantity = 0;

        try {
          const address = await fetch(`https://viacep.com.br/ws/${zip}/json/`)
            .then((response) => (response.ok ? response.json() : null))
            .catch(() => null);
          if (!address || address.erro || !address.uf) throw new Error('invalid');

          const cart = await fetch(`${this.root}cart.js`).then((response) => response.json());
          const line = cart.items.find((item) => String(item.variant_id) === String(variantId));
          originalQuantity = line ? line.quantity : 0;

          if (!line) {
            const added = await this.postJson('cart/add.js', { items: [{ id: Number(variantId), quantity: 1 }] });
            if (!added.ok) throw new Error('unavailable');
            addedQuantity = 1;
          }

          const query = new URLSearchParams({
            'shipping_address[zip]': `${zip.slice(0, 5)}-${zip.slice(5)}`,
            'shipping_address[country]': 'Brazil',
            'shipping_address[province]': address.uf,
          }).toString();

          const rates = await this.fetchRates(query);

          if (rates.length === 0) {
            this.show('<p class="rw-shipping__message">Não encontramos opções de entrega para este CEP.</p>');
          } else {
            const items = rates
              .map((rate) => {
                const days = this.formatDays(rate.delivery_days) || rate.description || '';
                const name = this.escape(rate.presentment_name || rate.name);
                return `<li class="rw-shipping__rate"><span class="rw-shipping__rate-name">${name}${days ? `<small>${this.escape(days)}</small>` : ''}</span><strong class="rw-shipping__rate-price">${this.formatMoney(rate.price)}</strong></li>`;
              })
              .join('');
            this.show(`<ul class="rw-shipping__rates">${items}</ul>`);
          }
        } catch (error) {
          const message =
            error.message === 'invalid'
              ? 'CEP não encontrado. Confira e tente novamente.'
              : error.message === 'unavailable'
              ? 'Produto indisponível para cálculo de frete.'
              : 'Não foi possível calcular o frete agora. Tente novamente.';
          this.show(`<p class="rw-shipping__message">${message}</p>`);
        } finally {
          if (addedQuantity > 0) {
            await this.postJson('cart/change.js', { id: String(variantId), quantity: originalQuantity }).catch(() => null);
          }
          this.button.disabled = false;
          this.button.textContent = 'Calcular';
        }
      }
    }

    customElements.define('rw-shipping-calculator', RwShippingCalculator);
  }
  } catch(e) { console.error(e); }
})();

})();
